import { Account } from "~billing/types/__generated/gql/graphql";
import { create } from "zustand";

interface State {
	tempSubscription: Account["subscription"]["paidConfig"] | null;
}

interface Actions {
	setTempSubscription: (data: State["tempSubscription"]) => void;
}

const initialState: State = {
	tempSubscription: null,
};

export const useSubscriptionStore = create<State & Actions>((set, _get) => ({
	...initialState,
	setTempSubscription: (data) =>
		set({
			tempSubscription: data,
		}),
}));
